import React, { useEffect } from "react";
/* Components */
import PAs from "./PAs";
/* Selectors */
import { selectSetting } from "@store/settings/selectors";
/* Redux */
import { SET_SELECTED_PA } from "@store/premiumsAccounts/actionTypes";
import { connect, useDispatch } from "react-redux";

const PATable = ({ pas, state, mode }) => {
  let dispatch = useDispatch();

  useEffect(() => {
    dispatch({ type: SET_SELECTED_PA, address: "" });
  }, [dispatch]);

  return <PAs pas={pas} state={state.PAReducer} mode={mode} />;
};

const mapStateToProps = (state) => {
  const pas = state.PAReducer.pas;
  const mode = selectSetting(state.SettingsReducer, "VIEW_MODE");

  return { pas, state, mode };
};

export default connect(mapStateToProps)(PATable);
